import overrideTableStyles from './Table'
import overrideCardStyles from "Theme/overrides/Card"
import overridePaperStyles from "Theme/overrides/Paper"


const overrideComponents = theme => Object.assign(
	overrideTableStyles(theme),
	overrideCardStyles(theme),
	overridePaperStyles(theme),
)

export default overrideComponents